import { APIScope } from "@swivl-mono/types";

import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";
import { Visibility, useVisibility } from "../../Hooks/WorksheetRow.Hooks";

interface ShowIfProps {
  scope?: APIScope;
  hideIf?: any;
  inGroupId?: number;
  inLocationId?: number;
  children: React.ReactNode;
}

export function ShowIf(props: ShowIfProps) {
  const hasPermissions = useHasPermission(props.scope, props.inGroupId, props.inLocationId);
  const visibility = useVisibility({ hideIf: props.hideIf, groupId: props.inGroupId, locationId: props.inLocationId });

  if (hasPermissions && visibility === Visibility.SHOW) {
    return props.children;
  }
  return null;
}
